<template>
  <div class="modal-reports-schedule-edit modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Расписание отчетов</h2>
        <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <schedule-editor v-model="schedule"></schedule-editor>
      </div>

      <div class="modal-footer">
        <btn-action class="btn btn-primary" @click="save">Сохранить</btn-action>
        <button type="button" class="btn btn-light" @click="$emit('hide')" style="border-color: transparent;">Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import {range} from 'lodash'
  import ScheduleEditor from './schedule/editor.vue'

  export default {
    props: ['value', 'ids'],
    components: {ScheduleEditor},
    data () {
      return {
        schedule: this.value,
      }
    },
    methods: {
      range,
      save () {
        return api.post(`schedules`, {
          reports_schedule: this.schedule,
          ids: this.ids,
        }).then(() => {
          this.$emit('hide', this.schedule)
        })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reports-schedule-edit-modal.vue